import { Redirect } from 'expo-router';

import { useAuthContext } from '@fhs/auth/src/hooks';
import { InStoreRedeemScreen } from '@fhs/loyalty';
import InStoreRewards from '@fhs-legacy/frontend/src/pages/in-store-rewards';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function Redeem() {
  const isRewardsTiersEnabled = useFlag('enable-rewards-tiers');
  const { isAuthenticated } = useAuthContext();

  if (isRewardsTiersEnabled) {
    if (!isAuthenticated) {
      return <Redirect href={routes.signInV2} />;
    }
    return <InStoreRedeemScreen />;
  }

  return <InStoreRewards />;
}
